import { styled } from 'config/stitches.config'

export const StyledClientListPreview = styled('div', { '.Description': { color: '$gray' } })
